export default "__VITE_ASSET__B2L5l4HK__"